import React, { useEffect, useRef, useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import NumberFormat from "react-number-format";
import TrashCan from "../../Assets/Images/Trash_can.png";
import { ImSpinner2 } from "react-icons/im";

import { ButtonContainer } from "../../Components/Shared/ButtonComponent";
import { CartContext } from "../../context/CartContext";
import axios from "axios";
import { toast } from "react-toastify";
import { UserContext } from "../../context/userContext";

const CartItem = () => {
  const [qty, setQty] = useState();
  const [cart, setCart] = useState([]);
  const [totalDeliveryFee, setTotalDeliveryFee] = useState();
  let location = useLocation();
  const ImageRef = useRef();
  const [loading, setLoading] = useState(false);

  const toastOptions = {
    hideProgressBar: true,
    position: "top-right",
    theme: "colored",
  };

  useEffect(() => {
    window.scrollTo({ top: "0", left: "0", behavior: "smooth" });
  });

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("cart_order"));
    setCart(data);
  }, []);

  let chooseSex = location.state?.id;

  const { subTotalValue, setSubTotalValue, totalValue, setTotalValue } =
    useContext(CartContext);
  const { isLoggedIn } = useContext(UserContext);

  const userData = JSON.parse(localStorage.getItem("_2mseamlessTailoring"));
  let user = userData?.user;
  let token = userData?.token;
  let email = userData?.user?.email;
  let first_name = userData?.user?.first_name;
  let last_name = userData?.user?.last_name;

  const headers = {
    email: user?.email ?? "",
    authorization: token ?? "",
    redirect_url: "https://2mseamless-tailoring.vercel.app/success",
  };

  const deleteItem = (idx) => {
    const itemsLeft = cart?.filter((item, index) => idx !== index);
    setCart(itemsLeft);
    localStorage.setItem("cart_order", JSON.stringify(itemsLeft));
  };

  useEffect(() => {
    const qty = cart?.reduce((allQty, item) => {
      allQty = allQty + parseFloat(item.quantity);

      return allQty;
    }, 0);

    setQty(qty);
  }, [cart, qty]);

  useEffect(() => {
    const totalDeliveryPrice = cart?.reduce((total, item) => {
      const delFee = item.delivery_fee * item.quantity;
      total = total + delFee;
      return total;
    }, 0);
    setTotalDeliveryFee(totalDeliveryPrice);
  }, [cart]);

  useEffect(() => {
    const subTotal = cart?.reduce((total, item) => {
      const individualPrice = parseFloat(item.tailoring_price) * item.quantity;
      total = total + individualPrice;
      return total;
    }, 0);

    setSubTotalValue(subTotal);
    let Total = subTotal + totalDeliveryFee;
    setTotalValue(Total.toFixed(2));
  }, [cart, setSubTotalValue, setTotalValue, totalDeliveryFee]);

  const incrementItem = (id) => {
    const updatedItems = cart?.map((item) => {
      if (item._id === id) {
        item.quantity = item.quantity + 1;
        return item;
      } else {
        return item;
      }
    });

    setCart(updatedItems);
  };

  const decrementItem = (id) => {
    const updatedItems = cart?.map((item) => {
      if (item._id === id) {
        if (item.quantity > 1) {
          item.quantity = item.quantity - 1;
        }
        return item;
      } else {
        return item;
      }
    });
    setCart(updatedItems);
  };

  let tailoringData = cart?.map((item) => {
    return {
      quantity: item.quantity,
      tailoring_id: item.tailoring_id,
      delivery: item.delivery,
      delivery_address: item.delivery_address,
      delivery_fee: item.delivery_fee,
      from_state: item.from_state,
      lga: item.lga,
      pick_up: item.pick_up,
      size: item.size,
      to_state: item.to_state,
      whatsapp_number: item.whatsapp_number,
    };
  });

  const handlePlentyCheckout = () => {
    setLoading(true);
    if (isLoggedIn) {
      axios
        .post(
          "https://mseamless.herokuapp.com/api/v1/tailoring/cart/checkout",
          {
            cart_order: tailoringData,
            email,
            first_name,
            last_name,
          },
          {
            headers,
          }
        )
        .then((res) => {
          setLoading(false);
          const checkout_url = res?.data?.check_out?.responseBody?.checkoutUrl;
          window.location.href = checkout_url;
        })
        .then(() => {
          localStorage.removeItem("cart_order");
        });
    } else {
      toast.error("Please Login To Proceed", toastOptions);
    }
  };

  return (
    <div className="col-12 cart-item">
      <h2>Cart</h2>
      <div>
        <p>
          <Link
            to={
              chooseSex === 1
                ? "/tailoring/malestyle"
                : "/tailoring/femalestyle"
            }
          >
            <button className="male_backarrow">
              <i className="fa-solid fa-arrow-left"></i>
            </button>
          </Link>
          <span>
            <strong>Continue Shopping</strong>
          </span>
        </p>
        <div>
          {cart?.length === 0 && (
            <p className="empty_cart">Your Cart is Empty</p>
          )}
        </div>

        <div className="cart-details">
          <div>
            {cart?.map((item, index) => (
              <div key={index} className="cart-content col-12">
                <div className="cart_img">
                  <img
                    alt="img"
                    ref={ImageRef}
                    src={item.tailoring_image_url[0]}
                  />
                  <div className="cart_name">
                    <div className="cartname">
                      <div>{item.tailoring_name}</div>
                      <div>Description</div>
                      <div>{item.size}</div>
                    </div>
                    <div className="change_quantity cart-quantity">
                      <span onClick={() => decrementItem(item._id)}>
                        <i className="fa-solid fa-minus"></i>
                      </span>
                      <span>{item.quantity}</span>
                      <span onClick={() => incrementItem(item._id)}>
                        <i className="fa-solid fa-plus"></i>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="cart_price">
                  <span onClick={() => deleteItem(index)}>
                    <img alt="trashcan" src={TrashCan} />
                  </span>
                  <span>
                    <NumberFormat
                      value={item.totalPrice}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"₦"}
                    />
                  </span>
                </div>
              </div>
            ))}
          </div>
          {cart?.length > 0 && (
            <div className="cart-summary">
              <h3>Cart Totals</h3>
              <table id="cart-sum">
                <tbody>
                  <tr>
                    <td>SUBTOTAL</td>
                    <td>
                      {" "}
                      <NumberFormat
                        value={subTotalValue}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>DELIVERY</td>
                    <td>{totalDeliveryFee}</td>
                  </tr>
                  <tr>
                    <td>Total Quantity</td>
                    <td>{qty}</td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td>
                      {" "}
                      <NumberFormat
                        value={totalValue}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <ButtonContainer
                disabled={loading}
                onClick={() => handlePlentyCheckout()}
              >
                {loading ? <ImSpinner2 className="spin" /> : "Proceed"}
              </ButtonContainer>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartItem;
